















































































































































import {Component, Vue, Prop, PropSync, Watch, Emit} from 'vue-property-decorator';
import DxScrollView from 'devextreme-vue/scroll-view';
import { DxDropDownBox } from 'devextreme-vue/drop-down-box';
import { DxCheckBox } from 'devextreme-vue/check-box';
import {
  EcoFilialSelectionType,
  EcoNodeSelectionType,
  GroupedObjects,
  SelectedGroupedObjects
} from '@/services/models-service';
import { numeralForm } from '@/utils/numbers';



@Component({
  name: 'TreeDropDownBoxBalance',
  components: {
    DxScrollView,
    DxDropDownBox,
    DxCheckBox,
  }
})
export default class extends Vue {
  @PropSync('selection') public selectionBlock: EcoFilialSelectionType[];
  @PropSync('grouped', {default: () => []}) public gropedObjects: SelectedGroupedObjects[];
  @PropSync('selectAll', {default: false}) public checkAllFilials: boolean;
  @Prop() public title!: string;
  @Prop({default: false}) public disabled!: boolean;
  @Prop({default: false}) public showFacility!: boolean;
  @Prop({default: false}) public enableSelectAllCheckbox!: boolean;
  @Prop({default: false}) public oneActiveCheck!: boolean;


  onRightClickFacility(filialId: number, nodeId: number, facilityId: number) {
    const filial = this.selectionBlock.find(f => f.id === filialId);
    if (!filial) return;
    
    const node = filial.nodes.find(n => n.id === nodeId);
    if (!node || !node.facilities) return;

    // ПКМ на объект: переключаем объект (у объекта нет детей)
    const facility = node.facilities.find(f => f.id === facilityId);
    if (facility) {
      facility.check = !facility.check;
      // Обновляем родительский узел после изменения объекта
      this.updateNodeCheckFromFacilities(node, filial);
      // Обновляем родительский филиал после изменения узла
      this.updateFilialCheckFromNodes(filial);
      this.updateSelectAllCheckbox();
      this.emitChanges();
    }
  }

  private onRightClickNode(filialId: number, nodeId: number) {
    const filial = this.selectionBlock.find(f => f.id === filialId);
    if (!filial) return;

    const node = filial.nodes.find(n => n.id === nodeId);
    if (!node) return;

    // ПКМ на узел: каскадное выделение узла и всех его объектов
    const newValue = !node.check;
    this.setNodeCheckDirect(node, newValue);
    // Обновляем родительский филиал после каскадного выделения
    this.updateFilialCheckFromNodes(filial);
    this.updateSelectAllCheckbox();
    this.emitChanges();
  }

  private onRightClickSelectAll() {
    // ПКМ на "ПАО ТПлюс": переключаем чекбокс и выбираем все филиалы (но не узлы и объекты)
    const newValue = !this.selectAllCheckbox;
    this.selectAllCheckbox = newValue;
    
    if (newValue) {
      // Выбираем все филиалы, но НЕ трогаем узлы и объекты
      this.selectionBlock.forEach(filial => {
        this.setFilialCheckOnly(filial, true);
      });
    } else {
      // Снимаем выбор со всех филиалов
      this.selectionBlock.forEach(filial => {
        this.setFilialCheckOnly(filial, false);
      });
    }
    
    this.emitChanges();
  }

  private onRightClickFilial(filialId: number) {
    const filial = this.selectionBlock.find(f => f.id === filialId);
    if (!filial) return;

    // ПКМ на филиал: каскадное выделение филиала, всех его узлов и всех объектов
    const newValue = !filial.check;
    // Меняем только филиал и его прямых детей (узлы), без каскада на объекты
    this.setFilialCheckDirectChildren(filial, newValue);
    // После каскадного выделения филиал уже будет в правильном состоянии
    // (true если все выбрано, false если все снято)
    this.updateSelectAllCheckbox();
    this.emitChanges();
  }
  private selectedNodes: number[] = [];
  private selectedObjects: number[] = [];
  private selectAllCheckbox = false;
  private expandedFilials: { [id: number]: boolean } = {};
  private expandedNodes: { [key: string]: boolean } = {};
  private isGroupedExpanded: boolean = true;



  private onDropDownValueChanged(e: any) {
    if (e.value === null) {
      this.clearAllSelections();
    }
  }



  private clearAllSelections() {
    this.selectionBlock.forEach(filial => {
      filial.check = false;
      filial.nodes.forEach(node => {
        node.check = false;
        if (node.facilities) {
          node.facilities.forEach(facility => facility.check = false);
        }
      });
    });
    
    this.gropedObjects.forEach(obj => obj.check = false);
    this.selectAllCheckbox = false;
    this.checkAllFilials = false;
    
    this.emitChanges();
  }



  private nodeKey(filialId: number, nodeId: number) {
    return filialId + ':' + nodeId;
  }



  private toggleGroupedSection() {
    this.isGroupedExpanded = !this.isGroupedExpanded;
  }



  isFilialExpanded(filialId: number) {
    return !!this.expandedFilials[filialId];
  }
  
  isNodeExpanded(filialId: number, nodeId: number) {
    return !!this.expandedNodes[this.nodeKey(filialId, nodeId)];
  }



  toggleFilial(filialId: number) {
    this.$set(this.expandedFilials, filialId, !this.isFilialExpanded(filialId));
  }
  
  toggleNode(filialId: number, nodeId: number) {
    const k = this.nodeKey(filialId, nodeId);
    this.$set(this.expandedNodes, k, !this.expandedNodes[k]);
  }



  mounted() {
    this.ensureExpandKeys(true);
    this.sortFacilitiesTree();
    // Синхронизируем selectAllCheckbox с checkAllFilials при загрузке
    if (this.enableSelectAllCheckbox) {
      this.selectAllCheckbox = this.checkAllFilials;
    }
  }



  private ensureExpandKeys(defaultExpanded: boolean) {
    (this.selectionBlock || []).forEach(f => {
      if (typeof this.expandedFilials[f.id] === 'undefined') {
        this.$set(this.expandedFilials, f.id, defaultExpanded);
      }
      (f.nodes || []).forEach(n => {
        const k = this.nodeKey(f.id, n.id);
        if (typeof this.expandedNodes[k] === 'undefined') {
          this.$set(this.expandedNodes, k, defaultExpanded);
        }
      });
    });
  }



  // ============= ОБРАБОТЧИКИ ИЗМЕНЕНИЙ =============



  onAllSelectionChanged(e: any) {
    // ЛКМ: только переключаем check чекбокса, не трогаем филиалы
    const newValue = e.value;
    this.selectAllCheckbox = newValue;
    this.emitChanges();
  }



  onFilialCheckChanged(filialId: number, e: any) {
    const filial = this.selectionBlock.find(f => f.id === filialId);
    if (!filial) return;

    // ЛКМ: только переключаем check филиала, не трогаем детей и родителей
    filial.check = e.value;
    
    this.updateSelectAllCheckbox();
    this.emitChanges();
  }



  onNodeCheckChanged(filialId: number, nodeId: number, e: any) {
    const filial = this.selectionBlock.find(f => f.id === filialId);
    if (!filial) return;

    const node = filial.nodes.find(n => n.id === nodeId);
    if (!node) return;

    // ЛКМ: только переключаем check узла, не трогаем детей и родителей
    node.check = e.value;
    
    this.updateSelectAllCheckbox();
    this.emitChanges();
  }



  onFacilityCheckChanged(filialId: number, nodeId: number, facilityId: number, e: any) {
    const filial = this.selectionBlock.find(f => f.id === filialId);
    if (!filial) return;

    const node = filial.nodes.find(n => n.id === nodeId);
    if (!node || !node.facilities) return;

    const facility = node.facilities.find(f => f.id === facilityId);
    if (!facility) return;

    // ЛКМ: только переключаем check объекта, не трогаем родителей
    facility.check = e.value;
    
    this.updateSelectAllCheckbox();
    this.emitChanges();
  }



  onGroupedObjectChanged(id: string, e: any) {
    const o = this.gropedObjects.find(f => f.id === id);
    if (o) {
      o.check = e.value;
    }
  }


  private setFilialCheckDirect(filial: any, value: boolean) {
    filial.check = value;
    filial.nodes.forEach((node: any) => {
      this.setNodeCheckDirect(node, value);
    });
  }


  private setNodeCheckDirect(node: any, value: boolean) {
    node.check = value;
    if (this.showFacility && node.facilities) {
      node.facilities.forEach((facility: any) => {
        facility.check = value;
      });
    }
  }


  private setFilialCheckOnly(filial: any, value: boolean) {
    filial.check = value;
  }

  private setNodeCheckOnly(node: any, value: boolean) {
    node.check = value;
  }

  // Устанавливает состояние филиала и только его прямых детей (узлов),
  // не трогая объекты внутри узлов
  private setFilialCheckDirectChildren(filial: any, value: boolean) {
    this.setFilialCheckOnly(filial, value);
    filial.nodes.forEach((node: any) => {
      this.setNodeCheckOnly(node, value);
    });
  }

  /**
   * Обновляет состояние узла на основе его объектов
   * Вызывается только после ПКМ операций
   * true - все объекты выбраны
   * false - все объекты не выбраны или частично выбрано
   */
  private updateNodeCheckFromFacilities(node: any, filial?: any) {
    if (!node.facilities || node.facilities.length === 0) {
      return;
    }

    const checkedCount = node.facilities.filter((f: any) => f.check === true).length;
    const uncheckedCount = node.facilities.filter((f: any) => f.check === false).length;
    const totalCount = node.facilities.length;

    if (checkedCount === totalCount) {
      node.check = true;
    } else {
      node.check = false;
    }
  }



  /**
   * Обновляет состояние филиала на основе его узлов
   * Вызывается только после ПКМ операций
   * true - все узлы выбраны полностью
   * false - все узлы не выбраны или частично выбрано
   */
  private updateFilialCheckFromNodes(filial: any) {
    if (!filial.nodes || filial.nodes.length === 0) {
      return;
    }

    const fullCheckedCount = filial.nodes.filter((n: any) => n.check === true).length;
    const totalCount = filial.nodes.length;

    // Все узлы полностью выбраны
    if (fullCheckedCount === totalCount) {
      filial.check = true;
    }
    // Ни один узел не выбран или частично выбрано
    else {
      filial.check = false;
    }
  }



  private updateSelectAllCheckbox() {
    if (!this.enableSelectAllCheckbox) return;

    // Обновляем чекбокс только на основе состояния филиалов, если сам чекбокс не выбран
    // Если selectAllCheckbox уже true, он был выбран вручную и должен оставаться true
    if (!this.selectAllCheckbox) {
      const allChecked = this.selectionBlock.every(f => f.check === true);
      this.selectAllCheckbox = allChecked;
    }
    // Если selectAllCheckbox уже true, не меняем его - он был выбран вручную
  }



  private emitChanges() {
    // Массивы для selection-hierarchy-changed (с родительскими элементами)
    const hierarchyFilials: number[] = [];
    const hierarchyNodes: number[] = [];
    const hierarchyFacilities: number[] = [];
    
    // Массивы для selection-real-changed (только реально выбранные элементы)
    // Собираем ВСЕ элементы с check === true, независимо от состояния родителей
    const realFilials: number[] = [];
    const realNodes: number[] = [];
    const realFacilities: number[] = [];

    // Это должно работать независимо от того, выбраны ли другие элементы
    // ВАЖНО: selectAllCheckbox должен оставаться true, даже если выбраны другие элементы
    if (this.selectAllCheckbox) {
      console.log('this.selectAllCheckbox', this.selectAllCheckbox);
      // Это должно работать даже если выбраны другие элементы
      this.selectionBlock.forEach(filial => {
        hierarchyFilials.push(filial.id);
        filial.nodes.forEach(node => {
          hierarchyNodes.push(node.id);
          if (this.showFacility && node.facilities) {
            node.facilities.forEach(facility => {
              hierarchyFacilities.push(facility.id);
            });
          }
        });
      });
      // После добавления всех элементов, выходим из обработки индивидуальных выборов
      // так как все уже добавлено
    }

    // Обрабатываем индивидуальные выборы для selection-hierarchy-changed (только если ПАО ТПлюс не выбран)
    if (!this.selectAllCheckbox) {
      this.selectionBlock.forEach(filial => {
        // Обработка для selection-hierarchy-changed
        if (filial.check === true) {
          // Филиал выбран: добавляем филиал и все его узлы в hierarchy
          hierarchyFilials.push(filial.id);
          filial.nodes.forEach(node => {
            hierarchyNodes.push(node.id);
          });
        }

        filial.nodes.forEach(node => {
          // Для selection-hierarchy-changed: проверяем узел только если филиал не выбран
          if (filial.check !== true && node.check === true) {
            // Узел выбран (филиал не выбран): добавляем только узел в hierarchy
            hierarchyNodes.push(node.id);
          }

          // Для selection-hierarchy-changed: проверяем объекты только если филиал и узел не выбраны
          if (filial.check !== true && node.check !== true) {
            if (this.showFacility && node.facilities) {
              node.facilities.forEach(facility => {
                if (facility.check === true) {
                  // Объект выбран (узел и филиал не выбраны): добавляем родительский узел и объект в hierarchy
                  if (!hierarchyNodes.includes(node.id)) {
                    hierarchyNodes.push(node.id);
                  }
                  hierarchyFacilities.push(facility.id);
                }
              });
            }
          }
        });
      });
    }

    // Для selection-real-changed: всегда собираем реально выбранные элементы (независимо от ПАО ТПлюс)
    this.selectionBlock.forEach(filial => {
      if (filial.check === true) {
        realFilials.push(filial.id);
      }
      filial.nodes.forEach(node => {
        if (node.check === true) {
          realNodes.push(node.id);
        }
        if (this.showFacility && node.facilities) {
          node.facilities.forEach(facility => {
            if (facility.check === true) {
              realFacilities.push(facility.id);
            }
          });
        }
      });
    });

    // Эмит selection-hierarchy-changed (с родительскими элементами)
    // ВАЖНО: Если выбран ПАО ТПлюс, в hierarchy должны быть ВСЕ элементы, независимо от других выборов
    this.emitHierarchy({ 
      filials: hierarchyFilials, 
      nodes: hierarchyNodes, 
      facilities: hierarchyFacilities 
    });
    
    // Эмит selection-real-changed (только реально выбранные элементы)
    // t_plus должен быть true, если выбран ПАО ТПлюс, даже если выбраны другие элементы
    this.emitRealSelection({ 
      filials: realFilials, 
      nodes: realNodes, 
      facilities: realFacilities,
      t_plus: this.selectAllCheckbox
    });
  }



  @Emit('selection-hierarchy-changed')
  private emitHierarchy(payload: {
    filials: number[];
    nodes: number[];
    facilities: number[];
  }): {
    filials: number[];
    nodes: number[];
    facilities: number[];
  } {
    console.log('emitHierarchy', payload);
    return payload;
  }

  @Emit('selection-real-changed')
  private emitRealSelection(payload: {
    filials: number[];
    nodes: number[];
    facilities: number[];
    t_plus: boolean;
  }): {
    filials: number[];
    nodes: number[];
    facilities: number[];
    t_plus: boolean;
  } {
    return payload;
  }



  @Emit('selection-grouped-objects-changed')
  private emitGroupedObjects(groupedObjects: string[]): string[] {
    return groupedObjects;
  }



  @Watch('gropedObjects', { deep: true })
  private onGroupedObjectsChanged() {
    const gropedObjects = new Set<string>();
    this.gropedObjects.forEach(sb => {
      if (sb.check) {
        gropedObjects.add(sb.id);
      }
    });
    this.emitGroupedObjects(Array.from(gropedObjects));
  }



  @Watch('selectionBlock', { deep: true })
  private onHierarchyChanged() {
    this.ensureExpandKeys(false);
    // Вызываем emitChanges после изменения selectionBlock для отправки реально отмеченных значений
    // Используем $nextTick чтобы убедиться, что все изменения применены
    this.$nextTick(() => {
      this.emitChanges();
    });
  }



  get displayValue(): string[] | null {
    const selectedNames: string[] = [];
    const selectedNodes: number[] = [];
    const selectedObjects: number[] = [];

    // Если выбран ПАО ТПлюс, добавляем его в список
    if (this.selectAllCheckbox && this.enableSelectAllCheckbox) {
      selectedNames.push('ПАО "Т Плюс"');
    }

    for (const filial of this.selectionBlock) {
      if (filial.check === true) {
        selectedNames.push(filial.name);
      }

      for (const node of filial.nodes) {
        if (node.check === true) {
          selectedNames.push(node.name);
          selectedNodes.push(node.id);
        }

        if (this.showFacility && node.facilities) {
          node.facilities.forEach(facility => {
            if (facility.check === true) {
              selectedNames.push(facility.name);
              selectedObjects.push(facility.id);
            }
          });
        }
      }
    }

    this.selectedNodes = selectedNodes;
    if (this.showFacility) {
      this.selectedObjects = selectedObjects;
    }

    this.gropedObjects.forEach(obj => {
      if (obj.check) {
        selectedNames.push(obj.title);
      }
    });

    return selectedNames;
  }



  private facilityComparator(a: any, b: any) {
    const priorityOrder = [25, 29, 30];
    const rank = (x: any) => {
      const id = Number(x?.object_type_id);
      const idx = priorityOrder.indexOf(id);
      return idx === -1 ? priorityOrder.length : idx;
    };



    const ra = rank(a);
    const rb = rank(b);
    if (ra !== rb) return ra - rb;



    const an = (a?.name ?? '').toString();
    const bn = (b?.name ?? '').toString();
    return an.localeCompare(bn, 'ru', { sensitivity: 'base', numeric: true });
  }



  private sortFacilitiesTree() {
    (this.selectionBlock || []).forEach(f => {
      (f?.nodes || []).forEach((n: any) => {
        if (Array.isArray(n?.facilities)) {
          n.facilities.sort((x: any, y: any) => this.facilityComparator(x, y));
        }
      });
    });
  }



  @Watch('selectionBlock', { immediate: true })
  private onSelectionReplaced(newVal: EcoFilialSelectionType[], oldVal: EcoFilialSelectionType[]) {
    if (!Array.isArray(this.selectionBlock)) return;
    this.sortFacilitiesTree();
    this.ensureExpandKeys(false);
  }

  @Watch('checkAllFilials', { immediate: true })
  private onCheckAllFilialsChanged(newValue: boolean) {
    // Синхронизируем selectAllCheckbox с checkAllFilials (который синхронизируется с preset.show_pao_tplus)
    if (this.enableSelectAllCheckbox) {
      this.selectAllCheckbox = newValue;
    }
  }
}
